<template>
  <section class="clip-reports-container page">
    <div class="header">
      <div class="container">
        <md-field
          class="md-field-year">
          <label for="year">Year</label>
          <md-select
            id="year"
            name="year"
            v-model="selectedYear">
            <md-option
              v-for="(year, index) in years"
              :key="index"
              :value="year">
              {{ year }}
            </md-option>
          </md-select>
        </md-field>
        <md-field
          class="md-field-month">
          <label for="month">Month</label>
          <md-select
            id="month"
            name="month"
            v-model="selectedMonth">
            <md-option
              v-for="(month, index) in months"
              :key="index"
              :value="index + 1">
              {{ month }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div
      class="clip-reports__loading"
      v-show="isLoading">
      <md-progress-spinner class="md-accent" md-mode="indeterminate" />
      <h3 class="loading-text">Loading...</h3>
    </div>
    <div
      class="clip-reports"
      v-if="!isLoading">
      <div class="container">
        <div class="clip-reports__analytics">
          <ReportAnalytics
            :clips="clips"
            :selectedMonth="selectedMonth"
            :selectedYear="selectedYear" />
          <ReportTable
            :clips="clips"
            :selectedMonth="selectedMonth"
            :selectedYear="selectedYear" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getDate } from 'date-fns';
import { loadMonthlyClips } from '@/api/TimeMachine';

import ReportAnalytics from './parts/report/ReportAnalytics.vue';
import ReportTable from './parts/report/ReportTable.vue';

export default {
  components: {
    ReportTable,
    ReportAnalytics,
  },
  data() {
    return {
      clips: [],
      state: {
        isLoading: false,
      },
      selectedMonth: null,
      selectedYear: null,
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      years: [],
    };
  },
  computed: {
    isLoading() {
      return this.state.isLoading;
    },
  },
  async created() {
    await this.initDates();
    await this.loadClips();
  },
  watch: {
    selectedMonth() {
      this.loadClips();
    },
    selectedYear() {
      this.loadClips();
    },
  },
  methods: {
    getDate,
    initDates() {
      this.state.isLoading = true;
      const now = new Date();
      this.selectedMonth = now.getMonth() + 1;
      this.selectedYear = now.getFullYear();
      this.years = [];
      for (let i = parseInt(this.selectedYear, 10); i >= 2019; i -= 1) {
        this.years.push(i);
      }
    },
    async loadClips() {
      this.state.isLoading = true;
      const response = await loadMonthlyClips(this.selectedYear, this.selectedMonth);
      this.clips = response.data;
      this.state.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.header {
  .container {
    .md-field-year {
      flex: 0 0 10%;
      margin-right: $spacer;
    }
    .md-field-month {
      flex: 0 0 20%;
    }
  }
}

.clip-reports__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-flow: column;
  height: 300px;
  .loading-text {
    margin-top: $spacer;
  }
}

.remove-filter:hover {
  cursor: pointer;
  text-decoration: underline;
}

.clip-reports__analytics {
  width: 100%;
  padding-top: $spacer;
}

@media screen and (max-width: 540px) {
  .header {
    .container {
      .md-field-year {
        flex: auto;
        margin-right: $spacer;
      }
      .md-field-month {
        flex: 1;
      }
    }
  }
}
</style>
